import buildRoute from './buildRoute'

export const getDealerProfiles = async (active: boolean) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'dealer-profiles',
            data: { active },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

export const addDealerProfile = async (formData: any) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'dealer-profile-edit',
            data: formData,
        })
        if (res.data) {
            return res
        }
    } catch (err: any) {
        console.error(err)
        return err
    }
}

export const getDealerProfileUsers = async (_id: string) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'dealer-profile-users',
            data: { _id },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

interface GetDealerProps {
    active: boolean
    page?: number
    limit?: number
    filter?: any
}

export const getDealerProfilesWithLimiter = async ({
    active,
    page = 1,
    limit = 50,
    filter,
}: GetDealerProps) => {
    try {
        let res: any
        res = await buildRoute({
            type: 'post',
            route: 'dealer-profiles-with-limiter',
            data: { active, page, limit, filter },
        })
        if (res.data) {
            return res.data
        }
    } catch (err: any) {
        return console.error(err)
    }
}

const dealerProfileRoutes = {
    getDealerProfiles,
    addDealerProfile,
    getDealerProfilesWithLimiter,
    getDealerProfileUsers,
}

export default dealerProfileRoutes
